const EXCHANGE_STATUS = {
  unassigned: 1, // Не назначен (на бирже не видно)
  market: 2, // На бирже (доступен для заявок)
  pending: 3, // Ожидает создания евента
  assigned: 4, // назначен
};

export default {
  EXCHANGE_STATUS,
};
